import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { initAttribution } from './analytics/attribution';
import { initGoogleAds } from './analytics/google-ads';
import { initAnalytics } from './analytics/posthog';
import { createQueryClient } from './api/query-client';
import App from './App';
import './index.css';

initAnalytics();
// Consent defaults and the Google tag before anything reads the consent state.
initGoogleAds();
initAttribution();

const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
